import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=3e352311&scoped=true"
import script from "./Competitor.vue?vue&type=script&lang=js"
export * from "./Competitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e352311",
  null
  
)

export default component.exports